<div class="page-shell">
<mat-toolbar class="header">
  <button mat-icon-button type="button" (click)="cancel()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span class="header__title">{{ "cardOrders.createTitle" | translate }}</span>
  <div class="actions" *ngIf="!loading">
    <p
      class="header-address-validation"
      [class.checkout-address-validation--validating]="addressValidationState === 'validating'"
      [class.checkout-address-validation--valid]="addressValidationState === 'valid'"
      [class.checkout-address-validation--invalid]="addressValidationState === 'invalid'"
      *ngIf="
        stepIndex === step.Checkout &&
        upsEnabled &&
        !isPickupDelivery &&
        addressValidationLabelKey
      "
    >
      {{ addressValidationLabelKey | translate }}
    </p>
    <button mat-stroked-button type="button" (click)="confirmClearDraft()">
      <mat-icon>delete_outline</mat-icon>
      {{ "cardOrders.clearDraft" | translate }}
    </button>
    <button
      mat-stroked-button
      type="button"
      *ngIf="showBackButton"
      (click)="goBack()"
    >
      {{ "cardOrders.back" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      *ngIf="showPrimaryNavButton"
      (click)="onPrimaryNav()"
      [disabled]="primaryNavDisabled"
    >
      <mat-spinner
        class="dc-btn-spinner"
        diameter="20"
        *ngIf="stepIndex === step.Summary && submitting"
      ></mat-spinner>
      {{ primaryNavLabelKey | translate }}
    </button>
  </div>
</mat-toolbar>

<div class="dc-wrapper">
  <div class="order-card">
    <div class="order-stepper-bar">
      <mat-stepper
        linear
        [selectedIndex]="stepIndex"
        class="order-stepper"
      >
        <mat-step [completed]="canProceedFromEmployees" *ngIf="!isSelfServiceOrder">
          <ng-template matStepLabel>{{ "cardOrders.stepEmployees" | translate }}</ng-template>
        </mat-step>
        <mat-step [completed]="canProceedFromCart">
          <ng-template matStepLabel>{{ "cardOrders.stepCards" | translate }}</ng-template>
        </mat-step>
        <mat-step [completed]="canProceedFromCart">
          <ng-template matStepLabel>{{ "cardOrders.stepCart" | translate }}</ng-template>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{ "cardOrders.stepCheckout" | translate }}</ng-template>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{ "cardOrders.stepSummary" | translate }}</ng-template>
        </mat-step>
      </mat-stepper>
    </div>

    <div class="order-shell">
      <div class="step-panel">
      <div class="step-shell" *ngIf="stepIndex === step.Employees && !isSelfServiceOrder">
        <div class="step-body">
          <section class="dc-section employees-browse">
            <div class="dc-section__header">
              <h2 class="dc-section__title">
                {{ "cardOrders.browseEmployees" | translate }}
                <span class="count-badge" *ngIf="selectedEmployees.length > 0">
                  {{ selectedEmployees.length }}
                </span>
              </h2>
            </div>
            <div class="dc-section__content">
              <div class="employees-step-toolbar">
                <button
                  mat-stroked-button
                  type="button"
                  (click)="toggleSelectAll()"
                  [disabled]="allPickerEmployees.length === 0"
                >
                  <mat-icon>{{ allEmployeesSelected ? "deselect" : "select_all" }}</mat-icon>
                  {{
                    (allEmployeesSelected ? "cardOrders.deselectAll" : "cardOrders.selectAll")
                      | translate
                  }}
                </button>
              </div>

              <div class="branch-filter" *ngIf="branches.length > 0">
                <span class="branch-filter__label">
                  {{ "cardOrders.selectByBranch" | translate }}
                </span>
                <div class="branch-chips">
                  <button
                    type="button"
                    class="branch-chip"
                    *ngFor="let branch of branches"
                    [class.branch-chip--selected]="isBranchSelected(branch.branchId)"
                    [disabled]="branch.employeeIds.length === 0"
                    (click)="toggleBranch(branch.branchId)"
                  >
                    {{ branch.name }}
                    <span class="branch-chip__count">{{ branch.employeeIds.length }}</span>
                  </button>
                </div>
              </div>

              <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
                <input
                  matInput
                  [formControl]="employeeSearchCtrl"
                  [placeholder]="'cardOrders.searchEmployees' | translate"
                  [attr.aria-label]="'cardOrders.searchEmployees' | translate"
                />
                <mat-icon matPrefix>search</mat-icon>
              </mat-form-field>
              <div *ngIf="!employeesLoading; else employeesLoadingState">
                <div class="dc-list" *ngIf="employeeOptions.length > 0; else employeesEmpty">
                  <button
                    type="button"
                    class="dc-list-item"
                    *ngFor="let employee of employeeOptions"
                    [class.dc-list-item--selected]="isEmployeeSelected(employee)"
                    (click)="toggleEmployee(employee)"
                  >
                    <mat-icon class="dc-list-item__icon">
                      {{ isEmployeeSelected(employee) ? "check_box" : "check_box_outline_blank" }}
                    </mat-icon>
                    <div class="dc-list-meta">
                      <span class="dc-list-name">{{ getEmployeeLabel(employee) }}</span>
                      <span class="dc-list-email">{{ employee.email }}</span>
                    </div>
                  </button>
                </div>
              </div>
              <mat-paginator
                class="employees-paginator"
                [length]="employeeListTotal"
                [pageIndex]="employeePageIndex"
                [pageSize]="employeePageSize"
                [pageSizeOptions]="employeePageSizeOptions"
                [disabled]="employeesLoading"
                (page)="changeEmployeePage($event)"
              ></mat-paginator>
            </div>
          </section>
        </div>
      </div>

      <div class="step-shell" *ngIf="stepIndex === step.Cards">
        <div class="step-body cards-step">
          <section class="dc-section self-service-employee" *ngIf="isSelfServiceOrder && activeEmployee">
            <div class="dc-section__header">
              <h2 class="dc-section__title">{{ "cardOrders.stepEmployees" | translate }}</h2>
            </div>
            <div class="dc-section__content">
              <div class="dc-list-item dc-list-item--selected self-service-employee__card">
                <mat-icon class="employee-status-icon">person_outline</mat-icon>
                <div class="dc-list-meta">
                  <span class="dc-list-name">{{ getEmployeeLabel(activeEmployee) }}</span>
                  <span class="dc-list-email">{{ activeEmployee.email }}</span>
                </div>
              </div>
            </div>
          </section>

          <div class="cards-step-summary" *ngIf="selectedEmployees.length > 0 && !isSelfServiceOrder">
            <div class="cards-step-summary__stats">
              <span>
                {{
                  "cardOrders.employeesInCartProgress"
                    | translate
                      : {
                          ready: employeesWithCartCount,
                          total: selectedEmployees.length
                        }
                }}
              </span>
              <span class="cards-step-summary__divider">·</span>
              <span>
                {{
                  "cardOrders.cartSummaryShort"
                    | translate
                      : {
                          items: cartLines.length,
                          quantity: totalCartQuantity
                        }
                }}
              </span>
            </div>
          </div>

          <div class="dc-layout cards-layout" [class.cards-layout--self-service]="isSelfServiceOrder">
            <section class="dc-section cards-column" *ngIf="!isSelfServiceOrder">
              <div class="dc-section__header">
                <h2 class="dc-section__title">{{ "cardOrders.selectedEmployees" | translate }}</h2>
              </div>
              <div class="dc-section__content">
                <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
                  <input
                    matInput
                    [formControl]="selectedEmployeeSearchCtrl"
                    [placeholder]="'cardOrders.searchEmployees' | translate"
                    [attr.aria-label]="'cardOrders.searchEmployees' | translate"
                  />
                  <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>
                <div>
                  <div
                    class="dc-list"
                    *ngIf="filteredSelectedEmployees.length > 0; else selectedEmployeesSearchEmpty"
                  >
                    <button
                      type="button"
                      class="dc-list-item"
                      *ngFor="let employee of filteredSelectedEmployees"
                      [class.dc-list-item--selected]="activeEmployee?.email === employee.email"
                      [class.dc-list-item--ready]="hasEmployeeCartItems(employee.email)"
                      (click)="selectActiveEmployee(employee)"
                    >
                      <mat-icon
                        class="employee-status-icon"
                        [class.employee-status-icon--ready]="hasEmployeeCartItems(employee.email)"
                      >
                        {{ hasEmployeeCartItems(employee.email) ? "check_circle" : "person_outline" }}
                      </mat-icon>
                      <div class="dc-list-meta">
                        <span class="dc-list-name">{{ getEmployeeLabel(employee) }}</span>
                        <span class="dc-list-email">{{ employee.email }}</span>
                      </div>
                      <span class="cart-badge" *ngIf="getEmployeeCartCount(employee.email) > 0">
                        {{ getEmployeeCartCount(employee.email) }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <section class="dc-section cards-column">
              <div class="dc-section__header">
                <h2 class="dc-section__title">{{ "cardOrders.templates" | translate }}</h2>
              </div>
              <div class="dc-section__content">
                <div *ngIf="!templatesLoading; else templatesLoadingState">
                  <div class="dc-list" *ngIf="availableTemplates.length > 0; else noTemplates">
                    <button
                      type="button"
                      class="dc-list-item"
                      *ngFor="let template of availableTemplates"
                      [class.dc-list-item--selected]="selectedTemplate?.printCardTemplateId === template.printCardTemplateId"
                      (click)="selectTemplate(template)"
                    >
                      <div class="dc-list-meta">
                        <span class="dc-list-name">{{ template.name }}</span>
                        <span class="dc-list-type">
                          {{ templateTypeLabelKey(template.type) | translate }}
                        </span>
                      </div>
                      <mat-icon
                        class="template-in-cart-icon"
                        *ngIf="isTemplateInActiveEmployeeCart(template.printCardTemplateId)"
                        [attr.aria-label]="'cardOrders.inCart' | translate"
                      >
                        check_circle
                      </mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <section class="dc-section cards-preview">
              <ng-container *ngIf="hasSelectedTemplate; else cardsPlaceholder">
                <div class="dc-section__header preview-panel__header">
                  <div class="preview-panel__title">
                    <h2 class="dc-section__title">{{ selectedTemplate!.name }}</h2>
                    <span class="preview-panel__employee" *ngIf="activeEmployee">
                      {{ getEmployeeLabel(activeEmployee) }}
                    </span>
                  </div>
                </div>

                <div
                  class="preview-panel__config preview-panel__config--preview-only"
                  *ngIf="isSelectedTemplatePreviewOnly; else orderConfigBlock"
                >
                  <mat-icon class="preview-panel__preview-only-icon">preview</mat-icon>
                  <p class="preview-panel__preview-only-text">
                    {{ "cardOrders.previewOnlyNotice" | translate }}
                  </p>
                </div>
                <ng-template #orderConfigBlock>
                  <div class="preview-panel__config">
                    <div class="preview-panel__config-fields">
                      <mat-form-field
                        *ngIf="!isPlasticNfcTemplateSelected"
                        appearance="outline"
                        subscriptSizing="dynamic"
                      >
                        <mat-label>{{ "cardOrders.pageSize" | translate }}</mat-label>
                        <mat-select
                          [value]="selectedPageSizePresetId"
                          (selectionChange)="onPageSizeChange($event.value)"
                        >
                          <mat-option
                            *ngFor="let preset of availablePresets"
                            [value]="preset.id"
                            [disabled]="!isPageSizePresetSelectable(preset.id)"
                          >
                            {{ preset.labelKey | translate }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field
                        *ngIf="isPlasticNfcTemplateSelected"
                        appearance="outline"
                        subscriptSizing="dynamic"
                      >
                        <mat-label>{{ "cardOrders.pageSize" | translate }}</mat-label>
                        <input
                          matInput
                          [value]="getPresetLabel(selectedPageSizePresetId) | translate"
                          readonly
                          tabindex="-1"
                        />
                      </mat-form-field>
                      <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{ "cardOrders.quantity" | translate }}</mat-label>
                        @if (usesFreeformQuantity) {
                          <input
                            matInput
                            type="number"
                            [min]="freeformQuantityMin"
                            [max]="freeformQuantityMax"
                            [ngModel]="selectedQuantity"
                            (ngModelChange)="onQuantityChange($event); scheduleDraftPersist()"
                          />
                        } @else {
                          <mat-select
                            [(ngModel)]="selectedQuantity"
                            (ngModelChange)="onQuantityChange($event); scheduleDraftPersist()"
                          >
                            <mat-option *ngFor="let quantity of quantityOptions" [value]="quantity">
                              {{ quantity }}
                            </mat-option>
                          </mat-select>
                        }
                      </mat-form-field>
                    </div>
                    <div class="preview-panel__config-actions">
                      <button
                        mat-raised-button
                        color="primary"
                        type="button"
                        (click)="addToCart()"
                        [disabled]="!selectedPageSizePresetId || !activeEmployee"
                      >
                        <mat-icon>{{ currentCartLine ? "sync" : "add_shopping_cart" }}</mat-icon>
                        {{
                          (currentCartLine ? "cardOrders.updateCartLine" : "cardOrders.addToCart")
                            | translate
                        }}
                      </button>
                      <button
                        mat-stroked-button
                        color="primary"
                        type="button"
                        (click)="addToCartForAllEmployees()"
                        [disabled]="!canBulkAddToCart"
                      >
                        <mat-icon>groups</mat-icon>
                        {{
                          "cardOrders.addToCartForAll"
                            | translate : { count: selectedEmployees.length }
                        }}
                      </button>
                    </div>
                  </div>
                </ng-template>

                <div class="preview-panel__preview">
                  <app-print-card-preview
                    [frontDocumentHtml]="previewFrontHtml"
                    [backDocumentHtml]="previewBackHtml"
                    [loading]="previewLoading"
                    [pageWidthCm]="previewPageWidthCm"
                    [pageHeightCm]="previewPageHeightCm"
                  ></app-print-card-preview>
                </div>

                <div class="preview-panel__cart">
                  <h3 class="preview-panel__cart-title">
                    {{ "cardOrders.employeeCart" | translate }}
                  </h3>
                  <div
                    class="employee-cart-list"
                    *ngIf="activeEmployeeCartLines.length > 0; else employeeCartEmpty"
                  >
                    <article class="employee-cart-line" *ngFor="let line of activeEmployeeCartLines">
                      <div class="employee-cart-line__info">
                        <strong>{{ line.templateName }}</strong>
                        <span>
                          <ng-container *ngIf="cartLineTypeLabelKey(line) as typeKey">
                            {{ typeKey | translate }}
                            ·
                          </ng-container>
                          {{ getPresetLabel(line.pageSizePresetId) | translate }}
                          ·
                          {{ line.quantity }}
                          {{ "printCardOrders.quantityUnit" | translate }}
                        </span>
                      </div>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="removeCartLine(line.id)"
                        [attr.aria-label]="'cardOrders.removeFromCart' | translate"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </article>
                  </div>
                  <ng-template #employeeCartEmpty>
                    <p class="preview-panel__cart-empty">
                      {{ "cardOrders.emptyCart" | translate }}
                    </p>
                  </ng-template>
                </div>
              </ng-container>
            </section>
          </div>
        </div>
      </div>

      <div class="step-shell" *ngIf="stepIndex === step.Cart">
        <div class="step-body">
          <div class="cart-step" *ngIf="cartLines.length > 0; else emptyCart">
            <div class="cart-step-summary">
              {{
                "cardOrders.cartSummary"
                  | translate
                    : {
                        items: cartLines.length,
                        employees: cartEmployeeGroups.length,
                        quantity: totalCartQuantity
                      }
              }}
            </div>

            <section class="cart-employee-group" *ngFor="let group of cartEmployeeGroups">
              <header class="cart-employee-group__header">
                <div class="cart-employee-group__identity">
                  <strong>{{ getEmployeeLabel(group.employee) }}</strong>
                  <span>{{ group.employee.email }}</span>
                </div>
                <div class="cart-employee-group__meta">
                  <span class="cart-employee-group__count">
                    {{
                      "cardOrders.employeeCartItems"
                        | translate : { count: group.lines.length }
                    }}
                    ·
                    {{ sumLineQuantities(group.lines) }}
                    {{ "printCardOrders.quantityUnit" | translate }}
                  </span>
                  <button
                    mat-button
                    type="button"
                    class="cart-employee-group__remove"
                    (click)="removeEmployeeCartLines(group.employee.email)"
                  >
                    {{ "cardOrders.removeEmployeeFromCart" | translate }}
                  </button>
                </div>
              </header>

              <div class="cart-employee-group__lines">
                <article class="cart-line" *ngFor="let line of group.lines">
                  <div class="cart-line__info">
                    <strong>{{ line.templateName }}</strong>
                    <span>
                      <ng-container *ngIf="cartLineTypeLabelKey(line) as typeKey">
                        {{ typeKey | translate }}
                        ·
                      </ng-container>
                      {{ getPresetLabel(line.pageSizePresetId) | translate }}
                    </span>
                  </div>
                  <mat-form-field
                    appearance="outline"
                    class="cart-line__quantity"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>{{ "cardOrders.quantity" | translate }}</mat-label>
                    @if (isCartLineFreeformQuantity(line)) {
                      <input
                        matInput
                        type="number"
                        [min]="freeformQuantityMin"
                        [max]="freeformQuantityMax"
                        [ngModel]="line.quantity"
                        (ngModelChange)="updateCartQuantity(line.id, $event)"
                      />
                    } @else {
                      <mat-select
                        [value]="line.quantity"
                        (selectionChange)="updateCartQuantity(line.id, $event.value)"
                      >
                        <mat-option *ngFor="let quantity of getCartLineQuantityOptions(line)" [value]="quantity">
                          {{ quantity }}
                        </mat-option>
                      </mat-select>
                    }
                  </mat-form-field>
                  <button
                    mat-icon-button
                    type="button"
                    (click)="removeCartLine(line.id)"
                    [attr.aria-label]="'cardOrders.removeFromCart' | translate"
                  >
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </article>
              </div>
            </section>
          </div>
        </div>
      </div>

      <div class="inline-loading checkout-loading" *ngIf="stepIndex === step.Checkout && !checkoutReady">
        <mat-spinner diameter="28"></mat-spinner>
      </div>

      <form
        class="step-shell"
        *ngIf="stepIndex === step.Checkout && checkoutReady"
        [formGroup]="checkoutForm"
        (ngSubmit)="proceedToSummary()"
      >
        <div class="step-body">
          <section
            class="checkout-delivery-options"
            *ngIf="printerEnabled"
          >
            <div class="checkout-delivery-options__grid">
              <div
                class="checkout-delivery-options__field"
                *ngIf="shipmentMethodsView.length > 0"
              >
                <h3>{{ "printCardOrders.deliveryType" | translate }}</h3>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select
                    formControlName="deliveryType"
                    required
                    [errorStateMatcher]="errorStateMatcher"
                  >
                    <mat-option
                      *ngFor="let method of shipmentMethodsView"
                      [value]="method"
                    >
                      {{ getShipmentMethodLabelKey(method) | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="checkout-delivery-options__field">
                <h3>{{ "printCardOrders.deliverySpeed" | translate }}</h3>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select
                    formControlName="deliverySpeed"
                    required
                    [errorStateMatcher]="errorStateMatcher"
                  >
                    <mat-option
                      *ngFor="let speed of deliverySpeedOptions"
                      [value]="speed"
                    >
                      {{ getDeliverySpeedLabelKey(speed) | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                class="checkout-delivery-options__field"
                *ngIf="isSuperAdmin && showAdminProductionTime"
              >
                <h3>{{ "printCardOrders.productionTime" | translate }}</h3>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select
                    formControlName="productionTime"
                    required
                    [errorStateMatcher]="errorStateMatcher"
                  >
                    <mat-option
                      *ngFor="let productionTime of productionTimeOptions"
                      [value]="productionTime"
                    >
                      {{ getProductionTimeLabelKey(productionTime) | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </section>

          <section class="delivery-destination" *ngIf="canDeliverToBranchView && !isPickupDelivery">
            <h3>{{ "cardOrders.deliveryDestinationSection" | translate }}</h3>
            <mat-radio-group
              class="delivery-destination-list"
              [value]="deliveryDestination"
              (change)="setDeliveryDestination($event.value)"
            >
              <mat-radio-button value="branch" class="delivery-destination-option">
                <span class="delivery-destination-option__label">
                  {{ "cardOrders.deliveryDestinationBranch" | translate }}
                </span>
                <span
                  class="delivery-destination-option__meta"
                  *ngIf="deliverableBranchesView.length === 1"
                >
                  {{ deliverableBranchesView[0].shipping.branchName }}
                </span>
              </mat-radio-button>
              <mat-radio-button value="custom" class="delivery-destination-option">
                <span class="delivery-destination-option__label">
                  {{ "cardOrders.deliveryDestinationCustom" | translate }}
                </span>
              </mat-radio-button>
            </mat-radio-group>
          </section>

          <section
            class="branch-delivery-panel"
            *ngIf="!isPickupDelivery && !isCustomDeliveryView && selectedBranchShipping"
          >
            <mat-radio-group
              *ngIf="deliverableBranchesView.length > 1"
              class="branch-picker-list"
              [value]="selectedDeliveryBranchId"
              (change)="setDeliveryBranch($event.value)"
            >
              <mat-radio-button
                *ngFor="let item of deliverableBranchesView"
                [value]="item.branch.branchId"
                class="branch-picker-option"
              >
                <strong>{{ item.shipping.branchName }}</strong>
              </mat-radio-button>
            </mat-radio-group>
            <div class="branch-delivery-address">
              <h4>{{ "cardOrders.branchDeliveryAddress" | translate }}</h4>
              <span
                class="address-lines"
                *ngIf="selectedBranchShipping?.address as branchAddress"
              >
                <span
                  class="address-line"
                  *ngFor="let line of formatShippingAddressLines(branchAddress)"
                >
                  {{ line }}
                </span>
                <span
                  class="country-address-label address-country"
                  *ngIf="branchAddress.country?.trim() as countryCode"
                >
                  <img
                    class="country-select-flag"
                    [src]="getCountryFlagUrl(countryCode)"
                    width="20"
                    height="15"
                    alt=""
                  />
                  {{ getCountryDisplayName(countryCode) }}
                </span>
              </span>
            </div>
          </section>

          <section class="test-addresses" *ngIf="showTestShippingAddresses && !isPickupDelivery">
            <h3 class="test-addresses__title">
              {{ "cardOrders.testAddresses.title" | translate }}
            </h3>
            <p class="test-addresses__hint">
              {{ "cardOrders.testAddresses.hint" | translate }}
            </p>
            <div class="test-addresses__buttons">
              <button
                mat-stroked-button
                type="button"
                class="test-addresses__button"
                *ngFor="let address of testShippingAddresses"
                (click)="applyTestShippingAddress(address)"
              >
                {{ address.labelKey | translate }}
              </button>
            </div>
          </section>

          <div class="checkout-grid">
            <ng-container *ngIf="isCustomDeliveryView && !isPickupDelivery">
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "printCardOrders.addressLine1" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="line1"
                  required
                  [errorStateMatcher]="errorStateMatcher"
                  (blur)="onCheckoutAddressFieldBlur()"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "printCardOrders.addressLine2" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="line2"
                  (blur)="onCheckoutAddressFieldBlur()"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "printCardOrders.city" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="city"
                  required
                  [errorStateMatcher]="errorStateMatcher"
                  (blur)="onCheckoutAddressFieldBlur()"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "printCardOrders.postalCode" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="postalCode"
                  required
                  [errorStateMatcher]="errorStateMatcher"
                  (blur)="onCheckoutAddressFieldBlur()"
                />
              </mat-form-field>
              <app-country-select
                formControlName="country"
                [label]="'printCardOrders.country' | translate"
                [required]="true"
                [errorStateMatcher]="errorStateMatcher"
                (focusout)="onCheckoutAddressFieldBlur()"
              ></app-country-select>
            </ng-container>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.recipientName" | translate }}</mat-label>
              <input
                matInput
                formControlName="recipientName"
                required
                [errorStateMatcher]="errorStateMatcher"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.companyName" | translate }}</mat-label>
              <input matInput formControlName="companyName" maxlength="200" />
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.phone" | translate }}</mat-label>
              <input
                matInput
                formControlName="phone"
                [readonly]="branchPhoneReadonly"
                required
                [errorStateMatcher]="errorStateMatcher"
              />
            </mat-form-field>
          </div>

          <div
            class="access-points"
            *ngIf="upsEnabled && checkoutDeliveryType === 'ACCESS_POINT'"
          >
            <h3>{{ "printCardOrders.accessPoint" | translate }}</h3>
            <div class="inline-loading access-points-loading" *ngIf="accessPointsLoading">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
            <p
              class="access-points-empty"
              *ngIf="!accessPointsLoading && accessPoints.length === 0"
            >
              {{ "cardOrders.accessPointEmpty" | translate }}
            </p>
            <app-card-order-access-point
              *ngIf="!accessPointsLoading && accessPoints.length > 0"
              [points]="accessPoints"
              formControlName="accessPointId"
            ></app-card-order-access-point>
          </div>

          <section class="checkout-order-notes">
            <h3>{{ "printCardOrders.orderNotes" | translate }}</h3>
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>{{ "printCardOrders.orderNotesPlaceholder" | translate }}</mat-label>
              <textarea
                matInput
                formControlName="notes"
                rows="3"
                maxlength="2000"
              ></textarea>
            </mat-form-field>
          </section>
        </div>
      </form>

      <div class="step-shell" *ngIf="stepIndex === step.Summary">
        <div class="step-body step-body--summary">
          <section class="order-summary-section">
            <h3>{{ "cardOrders.summaryItemsSection" | translate }}</h3>
            <app-order-items-list
              [recipients]="summaryRecipients"
              [showPreviewActions]="true"
            ></app-order-items-list>
          </section>

          <section class="order-summary-section order-summary-section--delivery">
            <p
              class="order-summary-access-point-distance"
              *ngIf="
                selectedAccessPoint &&
                formatUpsAccessPointDistanceKm(selectedAccessPoint.distanceKm) as distance
              "
            >
              {{ "cardOrders.accessPointDistance" | translate : { distance } }}
            </p>
            <h3>{{ "cardOrders.summaryDeliverySection" | translate }}</h3>
            <div class="info-grid summary-info-grid">
              <div *ngIf="printerEnabled && checkoutShipping.deliveryType as deliveryType">
                <span class="label">{{ "printCardOrders.deliveryType" | translate }}</span>
                <span>{{ getShipmentMethodLabelKey(deliveryType) | translate }}</span>
              </div>
              <div *ngIf="printerEnabled && checkoutShipping.deliverySpeed as deliverySpeed">
                <span class="label">{{ "printCardOrders.deliverySpeed" | translate }}</span>
                <span>{{ getDeliverySpeedLabelKey(deliverySpeed) | translate }}</span>
              </div>
              <div
                *ngIf="
                  isSuperAdmin &&
                  showAdminProductionTime &&
                  printerEnabled &&
                  checkoutShipping.productionTime as productionTime
                "
              >
                <span class="label">{{ "printCardOrders.productionTime" | translate }}</span>
                <span>{{ getProductionTimeLabelKey(productionTime) | translate }}</span>
              </div>
              <div *ngIf="checkoutShipping.recipientName">
                <span class="label">{{ "printCardOrders.recipientName" | translate }}</span>
                <span>{{ checkoutShipping.recipientName }}</span>
              </div>
              <div *ngIf="checkoutShipping.companyName?.trim()">
                <span class="label">{{ "printCardOrders.companyName" | translate }}</span>
                <span>{{ checkoutShipping.companyName }}</span>
              </div>
              <div *ngIf="checkoutShipping.phone">
                <span class="label">{{ "printCardOrders.phone" | translate }}</span>
                <span>{{ checkoutShipping.phone }}</span>
              </div>
              <div *ngIf="canDeliverToBranchView && !isPickupDelivery" class="full-width-info">
                <span class="label">{{ "cardOrders.deliveryDestinationSection" | translate }}</span>
                <span>{{
                  (isCustomDeliveryView
                    ? "cardOrders.deliveryDestinationCustom"
                    : "cardOrders.deliveryDestinationBranch"
                  ) | translate
                }}</span>
              </div>
              <div
                *ngIf="!isPickupDelivery && !isCustomDeliveryView && selectedBranchShipping?.branchName as branchName"
                class="full-width-info"
              >
                <span class="label">{{ "cardOrders.branchDeliveryAddress" | translate }}</span>
                <span>{{ branchName }}</span>
              </div>
              <div *ngIf="!isPickupDelivery && checkoutShipping.line1?.trim()" class="full-width-info">
                <span class="label">{{ "printCardOrders.shippingAddress" | translate }}</span>
                <span class="address-lines">
                  <span
                    class="address-line"
                    *ngFor="let line of formatShippingAddressLines(checkoutShipping)"
                  >
                    {{ line }}
                  </span>
                  <span
                    class="country-address-label address-country"
                    *ngIf="checkoutShipping.country?.trim() as countryCode"
                  >
                    <img
                      class="country-select-flag"
                      [src]="getCountryFlagUrl(countryCode)"
                      width="20"
                      height="15"
                      alt=""
                    />
                    {{ getCountryDisplayName(countryCode) }}
                  </span>
                </span>
              </div>
              <div *ngIf="selectedAccessPoint as accessPoint" class="full-width-info">
                <span class="label">{{ "printCardOrders.accessPoint" | translate }}</span>
                <span class="access-point-detail">
                  <span>
                    {{ formatUpsAccessPointName(accessPoint.name) }},
                    {{ formatUpsAccessPointAddress(accessPoint) }}
                  </span>
                  <span
                    class="access-point-detail__distance"
                    *ngIf="formatUpsAccessPointDistanceKm(accessPoint.distanceKm) as accessPointDistance"
                  >
                    {{ "cardOrders.accessPointDistance" | translate : { distance: accessPointDistance } }}
                  </span>
                  <span
                    class="access-point-detail__hours"
                    *ngIf="formatUpsAccessPointOpeningHours(accessPoint.openingHours) as openingHours"
                  >
                    <span class="access-point-detail__hours-label">
                      {{ "cardOrders.accessPointOpeningHoursLabel" | translate }}
                    </span>
                    {{ openingHours }}
                  </span>
                </span>
              </div>
              <div *ngIf="checkoutShipping.notes?.trim()" class="full-width-info">
                <span class="label">{{ "printCardOrders.orderNotes" | translate }}</span>
                <span class="order-notes-text">{{ checkoutShipping.notes }}</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
    <app-loading></app-loading>
  </div>
</div>

<ng-template #employeesLoadingState>
  <div class="inline-loading">
    <mat-spinner diameter="28"></mat-spinner>
  </div>
</ng-template>

<ng-template #templatesLoadingState>
  <div class="inline-loading">
    <mat-spinner diameter="28"></mat-spinner>
  </div>
</ng-template>

<ng-template #employeesEmpty>
  <div class="step-empty">{{ "cardOrders.noEmployeesFound" | translate }}</div>
</ng-template>

<ng-template #selectedEmployeesSearchEmpty>
  <div class="step-empty step-empty--compact">{{ "cardOrders.noEmployeesFound" | translate }}</div>
</ng-template>

<ng-template #noTemplates>
  <div class="step-empty">{{ "printCards.noTemplates" | translate }}</div>
</ng-template>

<ng-template #cardsPlaceholder>
  <div class="preview-panel__placeholder">
    {{ "cardOrders.selectEmployeeAndTemplate" | translate }}
  </div>
</ng-template>

<ng-template #emptyCart>
  <div class="step-empty">{{ "cardOrders.emptyCart" | translate }}</div>
</ng-template>

